<template lang="pug">
  v-app
    div(v-if='!this.$cookies.get("log")')
      router-view
    div(v-else)
      Menu
</template>

<script>
import Menu from './views/Menu'
import Login from './views/Login'
export default {
  name: 'App',
  components: {
    Menu,
    Login
  }
}
</script>
